import { Button } from "@/shadcn/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/shadcn/components/ui/dropdown-menu";
import { AddFilterDateType, AddFilterPeopleType } from "@/types";
import React from "react";

type AddFiltersSearch = {
  addFilterRef: React.RefObject<HTMLDivElement>;
  handleAddFilter: (
    target: "date" | "people",
    filter: AddFilterDateType | AddFilterPeopleType
  ) => void;
};

const AddFiltersSearch: React.FC<AddFiltersSearch> = ({
  addFilterRef,
  handleAddFilter,
}) => {
  const dateTypes: Array<"Last Modified" | "Created Date" | "Completed Date"> =
    ["Last Modified", "Created Date", "Completed Date"];
  const peopleTypes: Array<
    "Assigned by" | "Created By" | "Updated By" | "Has Timer"
  > = ["Assigned by", "Created By", "Updated By", "Has Timer"];

  return (
    <div ref={addFilterRef} className="w-full">
      {/* Dropdown */}
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="justify-between w-full">
            Add filter
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-56"
          side="bottom"
          align="start"
          ref={addFilterRef}
        >
          <DropdownMenuGroup>
            {/* Date */}
            <DropdownMenuSub>
              <DropdownMenuSubTrigger unselectable="on">
                Date
              </DropdownMenuSubTrigger>
              <DropdownMenuPortal>
                <DropdownMenuSubContent ref={addFilterRef}>
                  {dateTypes.map((type, index) => (
                    <React.Fragment key={type + index}>
                      <DropdownMenuItem
                        onClick={() => {
                          handleAddFilter("date", type);
                        }}
                      >
                        {type}
                      </DropdownMenuItem>
                    </React.Fragment>
                  ))}
                </DropdownMenuSubContent>
              </DropdownMenuPortal>
            </DropdownMenuSub>
            {/* People */}
            <DropdownMenuSub>
              <DropdownMenuSubTrigger unselectable="on">
                People
              </DropdownMenuSubTrigger>
              <DropdownMenuPortal>
                <DropdownMenuSubContent ref={addFilterRef}>
                  {peopleTypes.map((type, index) => (
                    <React.Fragment key={type}>
                      <DropdownMenuItem
                        onClick={() => {
                          handleAddFilter("people", type);
                        }}
                      >
                        {type}
                      </DropdownMenuItem>
                      {/* {(index === 0 || index === 1) && (
                        <DropdownMenuSeparator />
                      )} */}
                    </React.Fragment>
                  ))}
                </DropdownMenuSubContent>
              </DropdownMenuPortal>
            </DropdownMenuSub>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
export default AddFiltersSearch;
